import batchHandleUrl from '../../../utils/url-handle.js'
export default {
  ...batchHandleUrl({
    tree: {
      url: '/apaas/cityarea/getCityTree',
      type: 'get'
    }
  }),
  list: {
    url: '/mall/cityarea/get?id=0',
    type: 'GET',
    parameter: {}
  },
  get: {
    url: '/mall/cityarea/get',
    type: 'get',
    parameter: {}
  }
}
